<template>
  <main class="rc-page">
    <slot/>
  </main>
</template>
<script>
  import TitleMixin from '@/mixins/title.mixin'
  export default {
    name: 'RcPage',
    mixins: [TitleMixin],
    props: {
      title: String
    },
    created () {
      this.updateTitle(this.title || '人人车')
    }
  }
</script>
<style lang="scss" >
  %content {
    width: 100%;
    height: 100%;
    // overflow: hidden;
  }

  html {
    @extend %content;

    body,
    #app {
      @extend %content;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  .rc-page {
    @extend %content;
  }
</style>
